import { Dispatch, Middleware } from 'redux';
import Event from '../Event';

// tslint:disable:typedef
const eventClassToObject: Middleware = () => (next: Dispatch<Event>) => (event: Event): { type: string } => {
    if (event instanceof Event) {
        return next({ ...event });
    }
    return next(event);
};

export default eventClassToObject;



// WEBPACK FOOTER //
// ./src/application/core/middleware/eventClassToObjectMiddleware.ts